import axios from 'axios';
import slice from 'lodash/slice';
import reduceRight from 'lodash/reduceRight';

export const addressByPostalCode = (postalCode) => {
  return jpPostalCodeData(postalCode)
    .then((response) => {
      let result = response.data.results[0];
      if (result) {
        // components elements:
        // 0: Postal code
        // 1: Address
        // 2..(last - 1): city, state
        // last: Country
        let components = response.data.results[0].address_components;
        let address = components[1].long_name;
        let city_state_components = slice(components, 2, components.length - 1);
        let city_state = reduceRight(
          city_state_components,
          function (result, element) {
            return (result += element.long_name);
          },
          ''
        );

        return { address, city_state };
      }
    })
    .catch((error) => {
      window.error = error;
      this.$logger.debug('Load address by postal code fail:', error);
      return {};
    });
};

const jpPostalCodeData = (postalCode) => {
  return googleGeocoder().get('/maps/api/geocode/json', {
    params: {
      address: postalCode,
      key: process.env.VUE_APP_GOOGLE_GEOCODE_API_KEY,
      language: 'ja',
      sensor: 'false ',
    },
  });
};

const googleGeocoder = () => {
  return axios.create({
    baseURL: 'https://maps.googleapis.com',
  });
};
